import "./Footer.css"
import twitter from "./../assets/twitter_footer.png"
import wallet from "./../assets/wallet_footer.png"

const buttons = [
    {
        img: twitter,
        text: "Mark Cuban Meme",
        link: "https://x.com/mcuban_meme",
    },
    {
        img: twitter,
        text: "Mark Cuban",
        link: "https://x.com/mcuban",
    },
    {
        img: wallet,
        text: "Buy now",
        link: "https://raydium.io/swap/?inputMint=sol&outputMint=CubanZGDS1ny9rodw3oUvbL75uTxDXJwFd2uhMyU7G8z",
    },
];

const clickToLink = (link) => {
    window.open(link, "_blank");
};

export const Footer = () => {
    return <div className="footer">
        <div className="footer_buttons">
            {buttons.map((button, index) => (
                <div
                    className="footer_button"
                    onClick={() => clickToLink(button.link)}
                    src={button.img}
                    alt={index}
                    draggable={false}
                >
                    <img src={button.img} alt={`button_${button.text}`} draggable={false} />
                    <span>{button.text}</span>
                </div>))}
        </div>
        <span className="footer_description">
            This token doesn't intend to be, or to be the subject of, an investment opportunity, investment contract, or security of any type. $CUBAN is a way to memefi Mark Cuban. Just have fun.
        </span>
    </div>
}